import {ResponseObject} from "../../types/chat";

export class ResponseFactory {
    static create(
        answerHtml: string,
        responseId: string = '',
        messageId: string = '',
        author: string = '',
        time: string = '',
        isError: boolean = false,
        useDefaultHtml: boolean = true
    ): ResponseObject {
        return {
            answerHtml,
            responseId,
            messageId,
            author,
            time,
            isError,
            useDefaultHtml
        }
    }
}